import { getCurrentEnvironment } from '@fourthwall/env';
export const PAYPAL_CONTAINER_ID = 'paypal-button-container';
export const STRIPE_PUBLIC_KEY = {
    development: 'pk_test_X7wIisrFADdWY38xlAsmfcoA000Fv3jBGY',
    staging: 'pk_test_X7wIisrFADdWY38xlAsmfcoA000Fv3jBGY',
    production: 'pk_live_xTzksuEaFwD5555NcCgpdciY00qd9I2ltG',
}[getCurrentEnvironment()];
